import ErrorPge from "../pages/Error";
import HomePage from "../pages/home/Page";
import { RouteObject } from "react-router";

import GetDonPage from "../pages/get-don/Page.tsx";
import GetDonSingle from "../pages/get-don/Single.tsx";
import TaskListPage from "../pages/get-don/TaskListPage.tsx";
import PromoCode from "@/components/common/tasks/promo-code/PromoCode.tsx";

import ChallengesPage from "../pages/challenges/Page";
import ChallengesAll from "../pages/challenges/ChallengesAll";
import ChallengesParticipate from "../pages/challenges/ChallengesParticipate";
import ChallengesSingle from "../pages/challenges/Single.tsx";
import ChallengesSingleMembers from "../pages/challenges/SingleParticipants.tsx";
import ChallengeAwardDetails from "@/pages/challenges/ChallengeAwardDetails.tsx";

import HistoryPage from "../pages/history/Page";

import NotificationsPage from "../pages/profile/notifications/Page.tsx";

import ProfilePage from "../pages/profile/Page";
import ProfileEditPage from "../pages/profile/edit/Edit.tsx";
import PremiumPage from "../pages/profile/buy-premium/Page";

import ReferralPage from "../pages/referral/Page";
import StaticPage from "../pages/page/Page.tsx";

import P2PPage from "../pages/p2p/Page";
import LoyaltyPage from "../pages/loyalty/Page";
import VouchersPage from "../pages/loyalty/VouchersPage";
import PartnersPage from "../pages/loyalty/PartnersPage";
import PartnerSinglePage from "../pages/loyalty/PartnerSinglePage";
import AuthPage from "../pages/auth/Page";
import AboutWinners from "@/pages/challenges/about-winners/AboutWinners.tsx";
import PageWrapper from "@/components/PageWrapper.tsx";
import LessonListPage from "@/pages/testing/LessonListPage";
import LessonDetailPage from "@/pages/testing/LessonDetailPage";
import TestTakingPage from "@/pages/testing/TestTakingPage";
import SurveyListPage from "@/pages/profile/surveys/Page";
import SurveyDetailPage from "@/pages/profile/surveys/Single";
import MyCardsPage from "@/pages/profile/cards/MyCardsPage";
import AddCardPage from "@/pages/profile/cards/AddCardPage";

export interface Route {
  path: string;
  element: React.ReactNode;
  index?: boolean;
  children?: Route[];
}

const pages: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/challenges",
    element: <ChallengesPage />,
    children: [
      {
        path: "",
        index: true,
        element: <ChallengesAll />,
      },
      {
        path: "my-participations",
        element: <ChallengesParticipate />,
      },
    ],
  },
  {
    path: "/challenges/:challengeId",
    element: <ChallengesSingle />,
  },
  {
    path: "/challenges/:challengeId/members",
    element: (
      <PageWrapper>
        <ChallengesSingleMembers />
      </PageWrapper>
    ),
  },
  {
    path: "/challenges/:challengeId/winners",
    element: (
      <PageWrapper>
        <AboutWinners />
      </PageWrapper>
    ),
  },
  {
    path: "/challenges/:challengeId/award-details",
    element: (
      <PageWrapper>
        <ChallengeAwardDetails />
      </PageWrapper>
    ),
  },
  {
    path: "get-don",
    element: <GetDonPage />,
  },
  {
    path: "/get-don/:taskCollectionId",
    element: <GetDonSingle />,
  },
  {
    path: "/get-don/:taskCollectionId/tasks",
    element: <TaskListPage />,
  },
  {
    path: "/get-don/:taskCollectionId/social",
    element: <TaskListPage />,
  },
  {
    path: "/get-don/:taskId/promo-code",
    element: <PromoCode />,
  },
  {
    path: "/history",
    element: <HistoryPage />,
  },
  {
    path: "/p2p",
    element: <P2PPage />,
  },
  {
    path: "/loyalty",
    element: <LoyaltyPage />,
  },
  {
    path: "/vouchers",
    element: <VouchersPage />,
  },
  {
    path: "/partners",
    element: <PartnersPage />,
  },
  {
    path: "/partners/:partnerId",
    element: <PartnerSinglePage />,
  },
  {
    path: "/premium-page",
    element: <PremiumPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/profile/edit",
    element: <ProfileEditPage />,
  },
  {
    path: "/profile/surveys",
    element: <SurveyListPage />,
  },
  {
    path: "/profile/surveys/:surveyId",
    element: <SurveyDetailPage />,
  },
  {
    path: "/profile/cards",
    element: <MyCardsPage />,
  },
  {
    path: "/profile/cards/add",
    element: <AddCardPage />,
  },
  {
    path: "/page/:slug",
    element: <StaticPage />,
  },
  {
    path: "/profile/premium",
    element: <PremiumPage />,
  },
  {
    path: "/referral",
    element: <ReferralPage />,
  },
  {
    path: "/notifications",
    element: <NotificationsPage />,
  },
  {
    path: "/testing",
    element: <LessonListPage />,
  },
  {
    path: "/testing/lesson/:lessonId",
    element: <LessonDetailPage />,
  },
  {
    path: "/testing/:lessonId/test/:testId",
    element: <TestTakingPage />,
  },
  {
    path: "*",
    element: <ErrorPge />,
  },
];

export default pages;
